import { gql } from '@guuru/graphql-common/gql';

const createNewExpertFromInvitation = gql(`#graphql
  mutation CreateNewExpertFromInvitation($input: CreateNewExpertFromInvitationInput!) {
    createNewExpertFromInvitation(input:$input)
  }
`);

export default createNewExpertFromInvitation;
